import { render } from "./AvatarInline.vue?vue&type=template&id=0436c308&scoped=true"
import script from "./AvatarInline.vue?vue&type=script&lang=js"
export * from "./AvatarInline.vue?vue&type=script&lang=js"

import "./AvatarInline.vue?vue&type=style&index=0&id=0436c308&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0436c308"]])

export default __exports__